module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/timeBird@2x_1fbc5c.png";